// extracted by mini-css-extract-plugin
export default {"header":"styles_header__jia-1","light":"styles_light__Vnoqa","dark":"styles_dark__2rusv"};